export default "src/content/themes/association-wordpress-theme/img/93faadf22669729044e1c7333784b0a6.png";